import BaseFilter from "./Base";
import {
    Filter,
    FilterValue,
    FilterRequest,
    Identifiable,
    Named
} from "../../Contracts";

export default class SelectionFilter extends BaseFilter implements Filter {
    /* Static generators for readability purposes and to avoid overloading the constructor with
       arguments. */
    static Request(
        id: string,
        name: string,
        request: FilterRequest,
        placeholder?: string
    ): SelectionFilter {
        const filter = new SelectionFilter( id, name, [], placeholder );
        filter.request = request;

        return filter;
    }

    static MultiRequest(
        id: string,
        name: string,
        request: FilterRequest,
        placeholder?: string
    ): SelectionFilter {
        const filter = SelectionFilter.Request( id, name, request, placeholder );
        filter.multi = true;

        return filter;
    }

    static MultiUseRequest(
        id: string,
        name: string,
        request: FilterRequest,
        placeholder?: string
    ): SelectionFilter {
        const filter = SelectionFilter.Request( id, name, request, placeholder );
        filter.unique = false;
        filter.multi = true;

        return filter;
    }

    static Multi(
        id: string,
        name: string,
        values: FilterValue[],
        placeholder?: string
    ): SelectionFilter {
        const filter = new SelectionFilter( id, name, values, placeholder );

        filter.multi = true;

        return filter;
    }

    static MultiUse(
        id: string,
        name: string,
        values: FilterValue[],
        placeholder?: string
    ): SelectionFilter {
        const filter = new SelectionFilter( id, name, values, placeholder );

        filter.unique = false;
        filter.multi = true;

        return filter;
    }

    Value: FilterValue[] = [];
    Searchable: boolean = true;

    private values: FilterValue[];
    private request!: FilterRequest;
    private multi: boolean;

    constructor( id: string, name: string, values: FilterValue[], placeholder?: string ) {
        super( id, name, placeholder );

        this.multi = false;
        this.values = values;
    }

    get Multi(): boolean { return this.multi; }
    get Values(): FilterValue[] { return this.values; }
    get Request(): FilterRequest { return this.request; }

    FormatValue(): ( number | string )[] | number | string {
        const ids = ( this.Value as Identifiable[] )
            .filter( ( item: Identifiable ): boolean => item !== undefined && item !== null )
            .map( ( item: Identifiable ): string | number => item.Id );

        if( ids.length === 0 )
            return [];

        if( ids.length === 1 )
            return ids[ 0 ];

        return ids;
    }

    Format(): string {
        const names = ( this.Value as Named[] )
            .filter( ( item: Named ): boolean => item !== undefined && item !== null )
            .map( ( item: Named ): string =>
                item.Name !== undefined && item.Name !== null
                    ? item.Name
                    : String( ( item as unknown as Identifiable ).Id )
            );

        return names.join( $t( "FILTER_or" ) );
    }
}
